import React, { createContext, useState } from 'react';

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

const updateFormData = (data) => {
  setFormData(prev => (typeof data === 'object' ? { ...prev, ...data } : { ...prev, [data.key]: data.value }));
};

  const resetFormData = () => setFormData({});

  return (
    <FormContext.Provider value={{
      formData,
      updateFormData,
      resetFormData,
      currentStep,
      setCurrentStep
    }}>
      {children}
    </FormContext.Provider>
  );
};
